<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NAknUN/tc-custom/9783988267924.jpg?1704425415196" alt="This image is the cover for the book A Quiet Valley, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Quiet Valley, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: "“COME, Dulcie! Dulcie, my dear! Not ready yet?” A spice of good-humored impatience breathed through the rich bass tones. George Rutherford stood in the hall of a somewhat primitive Welsh hotel. The door opening into a sitting-room, on one side, displayed sundry ladies and gentlemen, occupied or non-occupied in various ways. The door opening into the kitchen, on the other side, displayed a waiter or two in shirtsleeves, coming and going. The front door, opening on the hotel grounds, displayed a bare, gravelly space, with shrubs around, a short avenue of trees beyond, and glimpses of distant hills softly outlined against a blue sky. Mr. Rutherford was a man of perhaps five or six-and-thirty years, unusually tall and massive in make, yet not stout. Honest brown eyes looked out from beneath a brow of remarkable breadth, which was framed in an abundant growth of tawny hair, fine as silk in texture. Moustache and beard, of a somewhat darker hue than the hair upon his head, almost hid a mouth of characteristic and beautiful outlines. He stood at the foot of the staircase, grasping a huge, crook-handled walking stick as tall as himself; and blissfully unconscious of, or indifferent to, the attention he was attracting from the inmates of the drawing-room, while he called again, in tones “not loud, but deep” — “Dulcie, my dear, make haste!”"</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Agnes Giberne
      </h2>
      
      <p class="authorDescription body article">Agnes Giberne (19 November 1845 – 20 August 1939) was a prolific British novelist and scientific writer.  Her fiction was typical of Victorian evangelical fiction with moral or religious themes for children. She also wrote books on science for young people, a handful of historical novels, and one well-regarded biography.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a11a647c